import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Layout } from './components/Layout'
import { ErrorBoundary } from './components/ErrorBoundary'

const Home = lazy(() => import('./pages/Home').then((m) => ({ default: m.Home })))
const Projects = lazy(() => import('./pages/Projects').then((m) => ({ default: m.Projects })))
const ProjectDetailPage = lazy(() =>
  import('./pages/ProjectDetail').then((m) => ({ default: m.ProjectDetailPage }))
)
const About = lazy(() => import('./pages/About').then((m) => ({ default: m.About })))
const Contact = lazy(() => import('./pages/Contact').then((m) => ({ default: m.Contact })))
const Blog = lazy(() => import('./pages/Blog').then((m) => ({ default: m.Blog })))
const BlogPost = lazy(() => import('./pages/BlogPost').then((m) => ({ default: m.BlogPost })))
const Privacy = lazy(() => import('./pages/Privacy').then((m) => ({ default: m.Privacy })))
const Terms = lazy(() => import('./pages/Terms').then((m) => ({ default: m.Terms })))
const ProjectPrivacy = lazy(() =>
  import('./pages/ProjectPrivacy').then((m) => ({ default: m.ProjectPrivacy }))
)
const ProjectTerms = lazy(() =>
  import('./pages/ProjectTerms').then((m) => ({ default: m.ProjectTerms }))
)
const ProjectSupport = lazy(() =>
  import('./pages/ProjectSupport').then((m) => ({ default: m.ProjectSupport }))
)
const OpenSource = lazy(() =>
  import('./pages/OpenSource').then((m) => ({ default: m.OpenSource }))
)
const NotFound = lazy(() => import('./pages/NotFound').then((m) => ({ default: m.NotFound })))

function PageLoader() {
  return (
    <div
      className="flex items-center justify-center min-h-[60vh]"
      role="status"
      aria-live="polite"
    >
      <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  )
}

function App() {
  const { t } = useTranslation()

  return (
    <ErrorBoundary>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-text-primary focus:rounded-lg focus:shadow-lg"
      >
        {t('a11y.skipToContent')}
      </a>
      <Layout>
        <Suspense fallback={<PageLoader />}>
          <div id="main-content" tabIndex={-1}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:category/:project" element={<ProjectDetailPage />} />
              <Route path="/projects/:category/:project/privacy" element={<ProjectPrivacy />} />
              <Route path="/projects/:category/:project/terms" element={<ProjectTerms />} />
              <Route path="/projects/:category/:project/support" element={<ProjectSupport />} />
              <Route path="/opensource" element={<OpenSource />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Suspense>
      </Layout>
    </ErrorBoundary>
  )
}

export { App }
